import { Ref, useRef } from 'react'
import clsx from 'clsx'
import { HugeiconsIcon, HugeiconsIconProps } from '@hugeicons/react'

type Props = React.InputHTMLAttributes<HTMLTextAreaElement> & {
  Icon?: HugeiconsIconProps['icon']
  invalid?: boolean
  ref?: Ref<HTMLTextAreaElement>
  rows?: number
}

function Textarea({
  Icon,
  className,
  disabled,
  invalid = false,
  readOnly,
  ref: forwardedRef,
  ...input
}: Props) {
  const internalRef = useRef<HTMLTextAreaElement>(null)
  const ref = (forwardedRef ||
    internalRef) as React.RefObject<HTMLTextAreaElement>

  return (
    <div
      className={clsx(
        'flex cursor-text flex-row items-center gap-2 rounded-small border border-text bg-white text-regular text-text placeholder:text-text-light',
        !readOnly &&
          'px-4 py-2 focus-within:outline-solid focus-within:outline-primary',
        disabled && 'cursor-not-allowed border-text-light text-text-light',
        readOnly && 'cursor-text border-none',
        invalid && 'border-red-500',
        className
      )}
      onClick={() => ref.current?.focus()}
    >
      {Icon && <HugeiconsIcon icon={Icon} className="size-6" />}
      <textarea
        className="flex-1 bg-transparent outline-hidden read-only:resize-none disabled:resize-none"
        {...input}
        readOnly={readOnly}
        aria-invalid={invalid}
        aria-readonly={readOnly}
        disabled={disabled}
        ref={ref}
      />
    </div>
  )
}

export default Textarea
